import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  Group,
  NumberFormatter,
  Select,
  SelectProps,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandVisa,
  IconCheck,
  IconCreditCardOff,
  IconDownload,
  IconEdit,
  IconEye,
  IconMenuOrder,
  IconReload,
  IconRocket,
  IconSearch,
  IconShield,
  IconSquareXFilled,
  IconStatusChange,
  IconTransformFilled,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useMemo, useState, useTransition } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useHotkeys, useIsFirstRender } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconReceiptRefund,
  IconSandbox,
  IconTimeDuration15,
} from "@tabler/icons-react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import {
  keySearchSalesOrderListV2,
  repositoryPos,
  styleTableMantine,
  styleTableMantineExpress,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import useDynamicHeight from "../../_base/component/Core/hookBase";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { getValueById, isJSON } from "../../_base/helper/FunctionHelper";
import { SocketExtension } from "../../_base/socket/socket";
import { CREATEORDERSUCCESS } from "../../_base/socket/ToplicList";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { BASE_API_POS } from "../../config";
import { _localization } from "../../config/location";
import { green, olive_green, sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { SelectListItem } from "../../model/SelectListItem";
import DetailsSellView from "./DetailsSellView";
import ModalsDebtBricks from "./ModalDebtBricks";
import CloseOrderButton from "./RetailOrder/ModalComponent/CloseOrderButton";
import SalesDeleteOrder from "./SalesDeleteOrder";
import WarrantyHistoryModal from "./WarrantyHistoryModal";

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const SalesOrderViewV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //#region  table

  //data and fetching state
  const [isHaveNewOrder, setIsHaveNewOrder] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [listEmployeeSales, setListEmployeeSales] = useState<any[]>([]);

  // Warranty modal state
  const [warrantyModalOpened, setWarrantyModalOpened] = useState(false);
  const [warrantyData, setWarrantyData] = useState<any[]>([]);
  const [currentOrderNumber, setCurrentOrderNumber] = useState("");

  const dataChannel = [
    {
      text: "Lazada",
      value: "304",
    },
    {
      text: "Tiktok",
      value: "341",
    },
    {
      text: "Chat Zalo",
      value: "343",
    },
    {
      text: "Facebook",
      value: "62",
    },
    {
      text: "Shopee Mall",
      value: "63",
    },
    {
      text: "Shopee",
      value: "342",
    },
    {
      text: "Tổng đài",
      value: "66",
    },
    {
      text: "Khách đến showroom",
      value: "67",
    },
    {
      text: "Khách đặt đơn Website",
      value: "68",
    },
    {
      text: "Khách gọi điện cho nhân viên",
      value: "69",
    },
    {
      text: "Khách chat qua website",
      value: "101",
    },
  ];

  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Có nhập lại", value: "CO_NHAP_LAI" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const _searchJson = localStorage.getItem(keySearchSalesOrderListV2)
    ? JSON.parse(localStorage.getItem(keySearchSalesOrderListV2) ?? "")
    : null;
  const firstRender = useIsFirstRender();
  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  } as MRT_PaginationState);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const height = useDynamicHeight(360);
  const innitSearchReturn = {
    customerName: "",
    customerCode: "",
    customerTaxCode: "",
    serial: "",
    orderNumber: "",
    phone: "",
    keySearch: "",
    codeSal: "",
    attribute19: "",
    saleChannelId: "",
  };

  // console.log("_searchJson", _searchJson);
  const innitStateSearch = useMemo(
    () => ({
      invId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.InvId as string)
          : "",
      invOutwardId:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.InvOutwardId
          : "",
      customerId: firstRender && _searchJson ? _searchJson.CustomerId : "",
      StartDate:
        firstRender && _searchJson && _searchJson.StartDate && checkedPinSearch
          ? new Date(_searchJson.StartDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      EndDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.EndDate &&
        _searchJson.EndDate != null
          ? new Date(_searchJson.EndDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      orderStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderStatus
          : "",
      orderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderType
          : "",
      orderNumber:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OrderNumber
          : "",
      paymentStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.PaymentStatus
          : "",
      industry:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.Industry
          : "",
      keySearch:
        checkedPinSearch && firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      OutwardStatus:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.OutwardStatus
          : "",
      codeCustomer:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CodeCustomer
          : "",
      phone:
        checkedPinSearch && firstRender && _searchJson ? _searchJson.Phone : "",
      createBy:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.CreateBy
          : "",
      //Người hưởng số
      CodeSal:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CodeSal as string)
          : "",
      //Thời gian hoàn thành đơn
      FinishDate:
        firstRender && _searchJson && _searchJson.FinishDate && checkedPinSearch
          ? new Date(_searchJson.FinishDate)
          : null,
      //Ngày xuất kho
      OwDate:
        firstRender && _searchJson && _searchJson.OwDate && checkedPinSearch
          ? new Date(_searchJson.OwDate)
          : null,
      // Số điện thoại người bán
      SalePhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SalePhone
          : "",
      //Số điện thoại người bán
      BuyerPhone:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.BuyerPhone
          : "",
      // Mã voucher
      VourcherCode:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.VourcherCode
          : "",
      // Mã chứng từ
      attribute19:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.attribute19
          : "",
      saleChannelId:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.saleChannelId
          : "",
      SourceOrderType:
        checkedPinSearch && firstRender && _searchJson
          ? _searchJson.SourceOrderType
          : false,
    }),
    [firstRender, _searchJson, checkedPinSearch],
  );

  const [searchReturn, setSearchReturn] = useState({
    ...innitSearchReturn,
  });
  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });
  // const [search, setSearch] = useState({
  //   ...innitStateSearch,
  // });
  // useEffect(() => {
  //   setSearch(innitStateSearch);
  // }, []);
  const [refreshKeySearch, setRefreshKeySearch] = useState<any>({});

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const handleCloseOrder = async (row: any) => {
    if (!row?.id) {
      console.error("Không thể đóng đơn: Thiếu ID đơn hàng");
      return;
    }

    const reason = "T6"; // Lý do đóng đơn
    const url = `/api/v1/CreateSellItem/close?id=${row.id}&reason=${reason}`;

    try {
      const response = await repositoryPos.get(url);
      if (response?.status === 200) {
        console.log("Đơn hàng đã được đóng thành công.");
        // Thực hiện các hành động tiếp theo (ví dụ: cập nhật danh sách đơn hàng)
      } else {
        console.error(
          "Lỗi khi đóng đơn:",
          response?.data?.message || "Unknown error",
        );
      }
    } catch (error) {
      console.error("Lỗi khi gọi API đóng đơn:", error);
    }
  };

  const handleCheckPayment = async (row: any) => {
    const url = `/api/v1/CreateSellItem/payment?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/payment-order-return", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "payment",
          },
        });
      } else {
        navigate("/sell/payment-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "payment",
          },
        });
      }
    }
  };

  const handleCheckApproved = async (row: any) => {
    const url = `/api/v1/CreateSellItem/approve?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      if (row.original.orderType === "1") {
        navigate("/sell/approved-discount-order-wholesale", {
          state: {
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "approved",
          },
        });
      } else {
        navigate("/sell/approved-discount-order", {
          state: {
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "approved",
          },
        });
      }
    }
  };

  const handleCheckEdit = async (row: any) => {
    // check thêm orderType
    const url = `/api/v1/CreateSellItem/edit?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      if (row.original.orderType === "1") {
        navigate("/sell/revise-whole-order", {
          state: {
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "edit",
          },
        });
      } else {
        navigate("/sell/revise-order", {
          state: {
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "edit",
          },
        });
      }
    }
  };

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            // isReadOnly:
            //   location?.pathname === "/sell/sales-order-list-read-only"
            //     ? true
            //     : false,
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
            // isReadOnly:
            //   location?.pathname === "/sell/sales-order-list-read-only"
            //     ? true
            //     : false,
          },
        });
      }
    }
  };

  const handleCheckWarranty = async (row: any) => {
    try {
      const url = `/api/v1/CreateSellItem/get-history-approve?orderId=${row.original.id}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        setWarrantyData(response.data || []);
        setCurrentOrderNumber(row.original.orderNumber);
        setWarrantyModalOpened(true);
        // NotificationExtension.Success(
        //   "Lấy thông tin lịch sử thay đổi giá thành công!"
        // );
      } else {
        NotificationExtension.Fails(
          "Không thể lấy thông tin lịch sử thay đổi giá!",
        );
      }
    } catch (error) {
      NotificationExtension.Fails(
        "Có lỗi xảy ra khi lấy thông tin lịch sử thay đổi giá!",
      );
      console.error("Error checking warranty:", error);
    }
  };

  const getTextStatus = (row: any) => {
    return orderStatuses.find(
      (status) => status.value === row.original.orderStatus,
    )?.label;
  };

  const getShippingVendorText = (shippingVendor: string) => {
    switch (shippingVendor) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "HACOM":
        return "Nội bộ";
      default:
        return shippingVendor;
    }
  };

  const fetchData = async () => {
    if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
      setIsLoading(true);
      //   setIsRefetching(true);
      // setIsError(false);

      let queryParams = {
        Skip:
          firstRender && _searchJson
            ? _searchJson.Skip
            : pagination.pageIndex * pagination.pageSize,
        Take:
          firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
      } as any;
      try {
        // if (!firstRender) {
        const search = form.getValues();
        queryParams = {
          ...queryParams,
          // Skip: pagination.pageIndex * pagination.pageSize,
          // Take: pagination.pageSize,
          InvId: search.invId?.toString(),
          InvOutwardId: search.invOutwardId?.toString(),
          CustomerId: search.customerId?.toString(),
          StartDate: search.StartDate
            ? moment(search?.StartDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "",
          EndDate: search.EndDate
            ? moment(search?.EndDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "",
          OrderStatus: search.orderStatus?.toString(),
          OrderType: search.orderType ? search.orderType?.toString() : 0,
          OrderNumber: search.orderNumber?.toString()?.toUpperCase(),
          PaymentStatus: search.paymentStatus?.toString(),
          industry: search.industry?.toString(),
          OutwardStatus: search?.OutwardStatus?.toString(),
          KeySearch: search.keySearch?.toString(),
          CodeCustomer: search.codeCustomer?.toString(), // Thêm trường tìm kiếm mã khách hàng
          Phone: search.phone?.toString(), // Thêm trường tìm kiếm số điện thoại
          CreateBy: search.createBy?.toString(), // Thêm trường tìm kiếm người tạo
          CodeSal: search.CodeSal?.toString(), //Thêm người hưởng số
          FinishDate: search.FinishDate
            ? moment(search?.FinishDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "", //Thời gian hoàn thành đơn
          OwDate: search.OwDate
            ? moment(search?.OwDate).format("YYYY-MM-DDT00:00:00.000[Z]")
            : "", //ngày xuất kho
          SalePhone: search.SalePhone?.toString(), // Số điện thoại người bán
          VourcherCode: search.VourcherCode?.toString(), // Mã voucher
          BuyerPhone: search.BuyerPhone?.toString(),
          attribute19: search.attribute19?.toString(),
          saleChannelId: search.saleChannelId?.toString(), // Mã chứng từ
          SourceOrderType: search.SourceOrderType ? "4" : "",
        };
        // } else {
        //   const _searchJson = localStorage.getItem(keySearchSalesOrderListV2);
        //   if (_searchJson) {
        //     const _search = JSON.parse(_searchJson);
        //     if (_search) queryParams = _search;
        //   }
        // }

        const queryParamsReturn = {
          Skip: pagination.pageIndex * pagination.pageSize,
          Take: pagination.pageSize,
          CustomerName: searchReturn.customerName,
          CustomerCode: searchReturn.customerCode,
          CustomerTaxCode: searchReturn.customerTaxCode,
          Serial: searchReturn.serial,
          OrderNumber: searchReturn.orderNumber,
          Phone: searchReturn.phone,
          KeySearch: searchReturn.keySearch,
          CodeSal: searchReturn.codeSal,
          attribute19: search.attribute19, // Sử dụng từ form thay vì searchReturn
          saleChannelId: search.saleChannelId,
        };
        let url;

        if (location?.pathname === "/sell/sales-order-list-read-only") {
          url =
            "/api/v1/CreateSellItem/get-list-return-sale?" +
            Object.entries({
              ...queryParamsReturn,
              Skip: pagination.pageIndex * pagination.pageSize,
              Take: pagination.pageSize,
            })
              .filter(([key, value]) => {
                // Bỏ qua các trường rỗng, trừ Skip và Take
                return (
                  (value !== undefined && value !== "") ||
                  key === "Skip" ||
                  key === "Take"
                );
              })
              .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
              .join("&");
        } else {
          url =
            "/api/v1/CreateSellItem/get-list?IsAccountant=false&" +
            Object.entries(queryParams)
              .filter(([, value]) => value !== undefined && value !== "")
              .map(
                ([key, value]) =>
                  `${key}=${encodeURIComponent(
                    value as string | number | boolean,
                  )}`,
              )
              .join("&");
        }
        //   console.log(queryParams);
        const response = await repositoryPos.get<MessageResponse<any>>(url);

        if (response && response.success) {
          setData(response.data?.pagedList?.lists);
          startTransition(() => {
            setRowCount(response.totalCount);
            //     table.resetRowSelection();
          });
        }
      } catch (error) {
        //   setIsError(true);
        console.error(error);
      } finally {
        setIsLoading(false);
        //   setIsRefetching(false);
        localStorage.setItem(
          keySearchSalesOrderListV2,
          JSON.stringify(queryParams),
        );
      }
    } else {
      NotificationExtension.Fails("Vui lòng chọn khoảng thời gian tìm kiếm !");
    }
  };

  //hàm hủy đơn hàng
  const DeleteCancelOrder = (value: any, status: any) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Hủy đơn hàng!</Title>
        </>
      ),
      size: "auto",
      children: (
        <SalesDeleteOrder
          idItems={value}
          status={status}
          onSearch={fetchData}
          onClose={setDeleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  //Check gạch nợ đơn
  const modalsGND = (id: number) => {
    modals.openConfirmModal({
      title: <Title order={5}>Lịch sử gạch nợ đơn</Title>,
      size: "90vw",
      children: <ModalsDebtBricks id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const orderTypes = [
    { value: "1", label: "Bán buôn", color: "yellow" },
    { value: "2", label: "Bán lẻ", color: "indigo" },
    { value: "3", label: "Đơn đổi trả", color: "green" },
    { value: "4", label: "Đơn online", color: "blue" },
  ];

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_CHO_DUYET_DOI_TRA", label: "Đơn chờ duyệt đổi trả" },
    { value: "DON_DA_DUYET_DOI_TRA", label: "Đơn đã duyệt đổi trả" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];

  const openModal = (document: any, amount: number, order: string) =>
    modals.openConfirmModal({
      title: <Title order={4}>Danh sách sản phẩm trong đơn: {order}</Title>,
      children: <DetailsSellView e={document} amount={amount} />,
      size: "100%",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const OrderDetail = (e: any) => {
    const rows = e?.document?.map((element: any, index: number) => (
      <Table.Tr key={index}>
        <Table.Td>{index + 1}</Table.Td>
        <Table.Td>{element.itemCode}</Table.Td>
        <Table.Td>{element.primaryUomCode}</Table.Td>
        <Table.Td>{element.quality}</Table.Td>
        <Table.Td>
          {element.discountRate > 0 ? (
            element.discountRate + "%"
          ) : (
            <NumberFormatter
              value={(element.discountAmount as string | number) || 0}
              suffix="₫"
              thousandSeparator="."
              decimalSeparator=","
            />
          )}
        </Table.Td>
        <Table.Td>{element.discountAdded}</Table.Td>
        <Table.Td>
          <NumberFormatter
            value={(element.priceFinal as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        </Table.Td>
        <Table.Td>{element.vatPercent}</Table.Td>
        <Table.Td>
          <NumberFormatter
            value={(element.vatAmount as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        </Table.Td>
        <Table.Td>
          <NumberFormatter
            value={(element.attribute28 as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        </Table.Td>
        <Table.Td>
          <NumberFormatter
            value={(element.attribute29 as string | number) || 0}
            suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        </Table.Td>
        <Table.Td>
          <NumberFormatter
            value={(element.totalLineAmount as string | number) || 0}
            suffix=" ₫"
            thousandSeparator=","
          />
        </Table.Td>
        <Table.Td>{element.lineTyle}</Table.Td>
      </Table.Tr>
    ));
    return (
      <>
        <Table mt={10} withTableBorder withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>STT</Table.Th>
              <Table.Th>Mã sản phẩm</Table.Th>
              <Table.Th>Đơn vị tính</Table.Th>
              <Table.Th>Số lượng</Table.Th>
              <Table.Th>Chiết khấu</Table.Th>
              {/* <Table.Th>Tiền chiết khấu</Table.Th> */}
              <Table.Th>Giảm thêm đơn</Table.Th>
              <Table.Th>Tiền sau CK</Table.Th>
              <Table.Th>VAT (%)</Table.Th>
              <Table.Th>Tiền VAT</Table.Th>
              <Table.Th>KM phân bổ</Table.Th>
              <Table.Th>Xin giảm phân bổ</Table.Th>
              <Table.Th>Thành tiền</Table.Th>
              <Table.Th>Loại mặt hàng</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </>
    );
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 80,
        // enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) =>
          String(row.original.shippingPriority) === "1" ? (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                size="md"
                style={{ cursor: "pointer" }}
                leftSection={<IconRocket size={12} />}
                color={"red"}
                onDoubleClick={() => handleCheckView(row)}
              >
                {renderedCellValue === null
                  ? "KHÔNG HỢP LỆ"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ) : (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="md"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={() => handleCheckView(row)}
              >
                {renderedCellValue === null
                  ? "KHÔNG HỢP LỆ"
                  : renderedCellValue}
              </Badge>
            </Tooltip>
          ),
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "DON_CHO_DUYET_DOI_TRA":
              badgeColor = "orange";
              break;
            case "DON_DA_DUYET_DOI_TRA":
              badgeColor = "teal";
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataStatusGeneral,
              "label",
            )?.toUpperCase() || renderedCellValue}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          console.log("renderedCellValue", renderedCellValue);
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderType",
        header: "Loại đơn hàng",
        size: 150,
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const orderType = orderTypes.find(
            (type) => type.value === row.original.orderType?.toString(),
          );

          return (
            <Badge color={orderType?.color || "gray"}>
              {orderType?.label || "KHÔNG HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute16",
        header: "Mã ĐTCN",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "saleChannelId",
        header: "Kênh bán",
        Cell: ({ renderedCellValue }) => {
          const saleChannel = dataChannel.find(
            (channel) => channel.value === renderedCellValue?.toString(),
          );
          return saleChannel?.text || "KHÔNG HỢP LỆ";
        },
      },
      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue }) => (
        //   <>
        //     <AvatarUtils
        //       value={renderedCellValue?.toString().split("-")[0] ?? ""}
        //     />
        //   </>
        // ),
      },
      {
        accessorKey: "nvhs",
        header: "Người hưởng số",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "salePhone",
        header: "Số đt người bán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "creator",
        header: "Người tạo đơn đổi trả",
        // enableColumnActions: false,,
        size: 200,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          // Kiểm tra nếu orderType === 3 thì hiển thị, ngược lại không hiển thị
          return row.original.orderType == 3 ? <>{row.original.creator}</> : "";
        },
      },
      // {
      //   accessorKey: "attribute18",
      //   header: "Người hưởng doanh số",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      //   Cell: ({ renderedCellValue }) => (
      //     <>
      //       <AvatarUtils
      //         value={renderedCellValue?.toString().split("-")[0] ?? ""}
      //       />
      //     </>
      //   ),
      // },
      {
        accessorKey: "creationDate",
        header: "Ngày lập",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "orderDate",
        header: "Ngày hoàn thành",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      // {
      //   accessorKey: "address",
      //   header: "Địa chỉ",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "technicalChecked",
        header: "Dịch vụ kiểm tra",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => (
          <>
            {
              <>
                {(() => {
                  if (row.original.technicalChecked === 0) {
                    return <Badge color="indigo">Không yêu cầu</Badge>;
                  } else if (row.original.technicalChecked === 1) {
                    return <Badge color="grape">Lắp ráp(mới)</Badge>;
                  } else if (row.original.technicalChecked === 2) {
                    return <Badge color="cyan">Kiểm tra(mới)</Badge>;
                  } else if (row.original.technicalChecked === 3) {
                    return (
                      <Badge color={sky_blue.medium}>
                        Lắp ráp(mới)+Kiểm tra(mới)
                      </Badge>
                    );
                  } else {
                    return null; // Or any fallback UI if needed
                  }
                })()}
              </>
            }
          </>
        ),
      },
      {
        accessorKey: "attribute11",
        header: "KT đã kiểm tra",
        size: 260,
        Cell: ({ row }) => (
          <Badge color="blue">
            {row?.original?.attribute11
              ? row?.original?.attribute11
              : "Khách không yêu cầu kiểm tra"}
          </Badge>
        ),
      },
      {
        accessorKey: "deliveryStatus",
        header: "Trạng thái giao vận",
        Cell: ({ renderedCellValue, row }) => (
          <Badge size="sm" color="cyan">
            {row?.original?.deliveryStatus === null
              ? "KHONG_YEU_CAU"
              : row?.original?.deliveryStatus}
          </Badge>
        ),
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "tenNVGV",
        header: "Tên NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "sdtNVGV",
        header: "SĐT NV giao vận",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute46",
        header: "Thời gian GV tiếp nhận đơn",
        enableColumnFilter: false,
        size: 225,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "attribute45",
        header: "Thời gian GV hoàn thành đơn",
        size: 250,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ row }) =>
        //   String(row.original.orderNumber).includes("-DT") ? (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute63
        //         ? String(row.original.attribute63)?.split("-")[0]
        //         : row.original.customerName}
        //     </Text>
        //   ) : (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute36
        //         ? String(row.original.attribute36)?.split("-")[0]
        //         : row.original.customerName}
        //     </Text>
        //   ),
      },
      {
        accessorKey: "customerPhone",
        header: "SĐT khách hàng",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        // Cell: ({ row }) =>
        //   String(row.original.orderNumber).includes("-DT") ? (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute63
        //         ? String(row.original.attribute63)?.split("-")[1]
        //         : row.original.customerPhone}
        //     </Text>
        //   ) : (
        //     <Text fw={500} size="12.5px">
        //       {row.original.attribute36
        //         ? String(row.original.attribute36)?.split("-")[1]
        //         : row.original.customerPhone}
        //     </Text>
        //   ),
      },
      {
        accessorKey: "attribute36",
        header: "Tên người mua",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) =>
          String(row.original.orderNumber).includes("-DT") ? (
            <Text fw={500} size="11.5px">
              {row.original.attribute63
                ? String(row.original.attribute63)?.split("-")[0]
                : ""}
            </Text>
          ) : (
            <Text fw={500} size="11.5px">
              {row.original.attribute36
                ? String(row.original.attribute36)?.split("-")[0]
                : ""}
            </Text>
          ),
      },
      {
        accessorKey: "attribute36v2",
        header: "SĐT người mua",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) =>
          String(row.original.orderNumber).includes("-DT") ? (
            <Text fw={500} size="11.5px">
              {row.original.attribute63
                ? String(row.original.attribute63)?.split("-")[1]
                : ""}
            </Text>
          ) : (
            <Text fw={500} size="11.5px">
              {row.original.attribute36
                ? String(row.original.attribute36)?.split("-")[1]
                : ""}
            </Text>
          ),
      },
      // {
      //   accessorKey: "htttPriority",
      //   header: "HTTT dự kiến",
      // },
      {
        accessorKey: "totalAmount",
        header: "Tổng tiền hàng",
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          let priceTotal = 0;
          listAdd?.forEach((item: any) => {
            priceTotal += (item?.priceOnPriceList || 0) * (item?.quality || 0);
          });
          return <NumberFormatter value={priceTotal} thousandSeparator="," />;
        },
      },
      {
        accessorKey: "totalPromotion",
        header: "Tổng giảm trừ",
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let listAdd = row.original.orderDetail || [];
          const totalDiscount = listAdd.reduce((acc: number, item: any) => {
            const discountAmount = item.discountAmount || 0;
            return acc + discountAmount * (item.quality || 1);
          }, 0);
          const totalDiscountRate = listAdd.reduce((acc: number, item: any) => {
            const discountRate = item.discountRate || 0;
            const price = item.priceOnPriceList || 0;
            const quality = item.quality || 1;
            const discountValue = (discountRate / 100) * price * quality;
            return acc + discountValue;
          }, 0);
          const discountAddedTotal =
            Number(row.original.discountAddedTotal) || 0;
          const totalPromotionOrder =
            totalDiscount + totalDiscountRate + discountAddedTotal;
          return (
            <NumberFormatter
              value={totalPromotionOrder}
              thousandSeparator=","
            />
          );
        },
      },
      {
        accessorKey: "attribute1",
        header: "Phí ship",
        enableColumnFilter: false,
        Cell: ({ row }) => {
          let shippingFee = 0;
          try {
            if (row.original.attribute1) {
              const parsedData = JSON.parse(row.original.attribute1);
              shippingFee = parsedData?.deliveryFee || parsedData?.feeShip || 0;
            }
          } catch (error) {
            console.error("Lỗi parse attribute1 cho phí ship:", error);
          }

          return <NumberFormatter value={shippingFee} thousandSeparator="," />;
        },
      },
      {
        accessorKey: "amount",
        header: "Số tiền",
        size: 160,

        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix=" ₫"
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "paid",
        header: "Đã trả",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix="₫"
            thousandSeparator="."
            decimalSeparator=","
          />
        ),
      },
      {
        accessorKey: "remaining",
        header: "Còn nợ",
        size: 160,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <NumberFormatter
            value={(renderedCellValue as string | number) || 0}
            // suffix=" ₫"
            thousandSeparator=","
          />
        ),
      },
      {
        accessorKey: "attribute24",
        header: "PT thanh toán",
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="11.5px">
            {renderedCellValue || "Thu tiền ngay"}
          </Text>
        ),
      },
      {
        accessorKey: "printInvoiceCheck",
        header: "Xuất hóa đơn",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row }) => <>{row.original.printInvoiceCheck}</>,
      },
      {
        accessorKey: "attribute39",
        header: "Mã voucher",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "attribute27",
        header: "Số hóa đơn",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      // {
      //   accessorKey: "lastEditor",
      //   header: "Người chỉnh sửa cuối cùng",
      //   // enableColumnActions: false,,
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 155,
        // enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, row }) => (
          <Flex gap={10}>
            <Tooltip label="Danh sách sản phẩm trong đơn">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() =>
                  openModal(
                    row.original.orderDetail,
                    row.original.amount,
                    row.original.orderNumber,
                  )
                }
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            {location.pathname !== "/sell/sales-order-list-read-only" && (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {location.pathname == "/sell/sales-order-list-read-only" &&
                  row.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
                  !row?.original?.t9 && (
                    <>
                      <Tooltip label="Trả hàng">
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="red"
                        >
                          <IconTransformFilled
                            size={20}
                            onClick={() =>
                              navigate("/sell/return-order", {
                                state: {
                                  orderNumber: row.original.orderNumber,
                                  actionType: "return",
                                },
                              })
                            }
                          />
                        </ActionIcon>
                      </Tooltip>
                    </>
                  )}

                {location.pathname == "/sell/sales-order-list-read-only" &&
                  row.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
                  row.original?.t9 && (
                    <>
                      <Tooltip label="Đổi hàng">
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="lime"
                        >
                          <IconReceiptRefund
                            size={20}
                            onClick={() =>
                              navigate("/sell/exchange-order", {
                                state: {
                                  orderNumberOld: row.original.orderNumber,
                                  actionType: "doi",
                                },
                              })
                            }
                          />
                        </ActionIcon>
                      </Tooltip>
                    </>
                  )}

                {row.original.orderStatus === "DON_HANG_HOAN_THANH" && (
                  <Tooltip label="Lịch sử thay đổi giá">
                    <ActionIcon
                      disabled={row.original.orderStatus === null}
                      variant="light"
                      aria-label="Settings"
                      color="blue"
                      onClick={() => {
                        handleCheckWarranty(row);
                      }}
                    >
                      <IconShield size={20} />
                    </ActionIcon>
                  </Tooltip>
                )}

                {row.original.orderStatus === "DON_HANG_HOAN_THANH" &&
                row.original.attribute30 !== "1" ? (
                  <CloseOrderButton
                    row={row}
                    fetchData={() => fetchData()}
                  ></CloseOrderButton>
                ) : (
                  <>
                    {row.original.orderStatus !== "DON_HANG_HUY" &&
                    row.original.orderStatus !== "KHO_XUAT_HANG" &&
                    row.original.orderStatus !== "DON_HANG_DOI_TRA" &&
                    row.original.orderStatus !== "DON_HANG_DOI_TRA_TAM" ? (
                      <>
                        {row.original.orderStatus !==
                          "DON_HANG_DA_DUYET_GIAM" &&
                          row.original.orderStatus !== "DON_DA_DUYET_DOI_TRA" &&
                          row.original.orderStatus !==
                            "DON_HANG_CHO_DUYET_GIAM" &&
                          row.original.orderStatus !== "DON_HANG_CHOT" && (
                            <Tooltip label="Sửa đơn">
                              <ActionIcon
                                disabled={
                                  row.original.orderStatus ===
                                    "DON_HANG_HOAN_THANH" ||
                                  row.original.orderStatus === null ||
                                  row.original.orderStatus ===
                                    "DON_CHO_DUYET_DOI_TRA"
                                }
                                variant="light"
                                aria-label="Settings"
                                color="yellow"
                              >
                                <IconEdit
                                  size={20}
                                  onClick={() => {
                                    handleCheckEdit(row);
                                  }}
                                />
                              </ActionIcon>
                            </Tooltip>
                          )}

                        {(row.original.orderStatus === "DON_HANG_CHOT" ||
                          row.original.orderStatus ===
                            "DON_HANG_DA_DUYET_GIAM" ||
                          row.original.orderStatus ===
                            "DON_DA_DUYET_DOI_TRA") && (
                          <Tooltip label="Thanh toán">
                            <ActionIcon
                              disabled={
                                row.original.orderStatus ===
                                  "DON_HANG_HOAN_THANH" ||
                                row.original.orderStatus === null
                              }
                              variant="light"
                              aria-label="Settings"
                              color="green"
                            >
                              <IconBrandVisa
                                size={20}
                                onClick={() => {
                                  handleCheckPayment(row);
                                }}
                              />
                            </ActionIcon>
                          </Tooltip>
                        )}
                        {/* {row.original.orderStatus ===
                          "DON_HANG_CHO_DUYET_GIAM" && (
                          <Tooltip label="Duyệt giảm">
                            <ActionIcon
                              disabled={
                                row.original.orderStatus ===
                                  "DON_HANG_HOAN_THANH" ||
                                row.original.orderStatus === null
                              }
                              variant="light"
                              aria-label="Settings"
                              color="violet"
                              onClick={() => {
                                handleCheckApproved(row);
                              }}
                            >
                              <IconCoin size={20} onClick={() => {}} />
                            </ActionIcon>
                          </Tooltip>
                        )} */}
                      </>
                    ) : null}

                    {row.original.orderStatus !== "DON_HANG_HUY" &&
                    row.original.orderStatus !== "KHO_XUAT_HANG" &&
                    row.original.orderStatus !== "DON_HANG_DOI_TRA" &&
                    row.original.orderStatus !== "DON_HANG_DONG" ? (
                      <Tooltip
                        disabled={
                          row.original.orderStatus === "DON_HANG_HOAN_THANH"
                        }
                        label="Hủy đơn"
                      >
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="red"
                          disabled={
                            row.original.orderStatus === "DON_HANG_HOAN_THANH"
                          }
                          onClick={async () => {
                            DeleteCancelOrder(
                              row.original.orderNumber,
                              row.original.orderStatus,
                            );
                          }}
                        >
                          <IconSquareXFilled size={20} stroke={1.5} />
                        </ActionIcon>
                      </Tooltip>
                    ) : null}
                  </>
                )}
              </Box>
            )}
            <Tooltip label="Gạch nợ đơn">
              <ActionIcon
                variant="light"
                color="#31d79d"
                onClick={() => modalsGND(row.original.id)}
              >
                <IconCreditCardOff size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [location.pathname, dataStatusGeneral],
  );

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };
  // //Lưu ghim cột
  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningSaleOrderListV2",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : { left: ["STT", "orderNumber"], right: ["action"] }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningSaleOrderListV2",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["STT", "orderNumber"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    // onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style:
        String(row.original.shippingPriority) === "1"
          ? {
              fontWeight: "500",
              fontSize: "11.5px",
              padding: "6px 8px",
              color: "red",
            }
          : styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      // showAlertBanner: isError,
      // showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      columnPinning,
    },
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // displayColumnDefOptions: {
    //   "mrt-row-select": {
    //     size: 1,
    //   },
    //   "mrt-row-expand": {
    //     size: 1,
    //   },
    // },
  });

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    deleteViewStatus,
    refreshKeySearch,
  ]);

  useEffect(() => {
    SocketExtension.On(CREATEORDERSUCCESS, (arg: any) => {
      // fetchData();
      setIsHaveNewOrder(true);
    });
    return () => {
      SocketExtension.Off(CREATEORDERSUCCESS, () => {});
    };
  }, []);

  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={orderTypes.find((x) => x.value === option.value)?.color}
        radius="sm"
        variant="filled"
      ></Badge>
      {option.label}{" "}
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // // Lấy key search vào ở local storage
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    startTransition(() => {
      fetchDataBranch();
    });
  }, []);

  useEffect(() => {
    if (!checkedPinSearch) {
      form.setValues((prev) => ({ ...prev, keySearch: "" }));
    }
  }, [checkedPinSearch]);
  useHotkeys([["Enter", () => fetchData()]]);

  useEffect(() => {
    const fetchEmployeeBy = async () => {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmEmployee/get-all`,
      );
      if (response && response.success) {
        const result = response.data;
        const formattedData = result.map((employee: any) => ({
          value: employee.code, // Giá trị cho "value"
          label: `${employee.fullname}-${employee.code}`, // Giá trị cho "label"
        }));
        // Lọc trùng theo "value": mỗi value chỉ giữ lại 1 object đầu tiên
        const uniqueData = Array.from(
          new Map(
            formattedData.map((item: any) => [item.value, item]),
          ).values(),
        );
        setListEmployeeSales(uniqueData); // Lưu mảng đã format (đã lọc trùng) vào state
      }
    };
    fetchEmployeeBy();
  }, []);
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <div>
            <Button
              leftSection={<IconReload size={14} />}
              variant="blue"
              disabled={!isHaveNewOrder}
              mr={"xs"}
              onClick={() => {
                fetchData();
                setIsHaveNewOrder(false);
              }}
            >
              Cập nhật đơn mới
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              mr={"xs"}
              onClick={() => {
                if (form.getValues()?.StartDate && form.getValues()?.EndDate) {
                  const search = form.getValues();
                  const queryParams = {
                    Skip: pagination.pageIndex * pagination.pageSize,
                    Take: pagination.pageSize,
                    InvId: search.invId ? search.invId.toString() : "",
                    InvOutwardId: search.invOutwardId
                      ? search.invOutwardId.toString()
                      : "",
                    CustomerId: search.customerId
                      ? search.customerId.toString()
                      : "",
                    StartDate: search.StartDate
                      ? moment(search?.StartDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    EndDate: search.StartDate
                      ? moment(search?.EndDate).format(
                          "YYYY-MM-DDT00:00:00.000[Z]",
                        )
                      : "",
                    OrderStatus: search.orderStatus,
                    OrderType: search.orderType ? search.orderType : 0,
                    OrderNumber: search.orderNumber,
                    PaymentStatus: search.paymentStatus,
                    industry: search.industry,
                    OutwardStatus: search?.OutwardStatus,
                    BuyerPhone: search?.BuyerPhone,
                    CodeCustomer: search?.codeCustomer,
                    KeySearch: search.keySearch,
                    Phone: search?.phone,
                    SalePhone: search?.SalePhone,
                    attribute19: search.attribute19,
                    saleChannelId: search.saleChannelId,
                    SourceOrderType: search.SourceOrderType ? "4" : "",
                  };

                  let url;
                  url =
                    "/api/v1/CreateSellItem/export-sale-order?" +
                    Object.entries(queryParams)
                      .filter(
                        ([, value]) => value !== undefined && value !== "",
                      )
                      .map(
                        ([key, value]) => `${key}=${encodeURIComponent(value)}`,
                      )
                      .join("&");

                  const _url = BASE_API_POS + url;

                  const fullUrl = new URL(_url);

                  const token = localStorage.getItem("token");

                  fetch(fullUrl.toString(), {
                    method: "GET", // Use the appropriate HTTP method
                    headers: {
                      Authorization: `Bearer ${token?.replace(/"/g, "")}`,
                      "Content-Type": "application/vnd.ms-excel",
                    },
                  })
                    .then((response) => {
                      if (response.ok) {
                        return response.blob(); // Assuming the response is a file or blob
                      } else {
                        throw new Error("Failed to fetch the resource");
                      }
                    })
                    .then((blob) => {
                      // Open the blob in a new tab
                      const url = window.URL.createObjectURL(blob);
                      const _name = new Date().toISOString().slice(0, 10);
                      let filename = "bao_cao_ban_hang" + "-" + _name + ".xlsx"; // Tên mặc định nếu không có header
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = filename;
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      window.URL.revokeObjectURL(url);
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                } else {
                  NotificationExtension.Fails(
                    "Vui lòng chọn khoảng thời gian Export Excel !",
                  );
                }
              }}
            >
              Export Excel
            </Button>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={async () => {
                const search = form.getValues();
                const queryParams = {
                  // Skip: pagination.pageIndex * pagination.pageSize,
                  // Take: pagination.pageSize,
                  InvId: search.invId ? search.invId.toString() : "",
                  InvOutwardId: search.invOutwardId
                    ? search.invOutwardId.toString()
                    : "",
                  CustomerId: search.customerId
                    ? search.customerId.toString()
                    : "",
                  StartDate: search.StartDate
                    ? moment(search?.StartDate).format(
                        "YYYY-MM-DDT00:00:00.000[Z]",
                      )
                    : "",
                  EndDate: search.StartDate
                    ? moment(search?.EndDate).format(
                        "YYYY-MM-DDT00:00:00.000[Z]",
                      )
                    : "",
                  OrderStatus: search.orderStatus,
                  OrderType: search.orderType ? search.orderType : 0,
                  OrderNumber: search.orderNumber,
                  PaymentStatus: search.paymentStatus,
                  industry: search.industry,
                  OutwardStatus: search?.OutwardStatus,
                  BuyerPhone: search?.BuyerPhone,
                  CodeCustomer: search?.codeCustomer,
                  KeySearch: search.keySearch,
                  Phone: search?.phone,
                  SalePhone: search?.SalePhone,
                  attribute19: search.attribute19,
                  saleChannelId: search.saleChannelId,
                  SourceOrderType: search.SourceOrderType ? "4" : "",
                };

                try {
                  let url;
                  url =
                    "/api/v1/CreateSellItem/export-sale-order-async?" +
                    Object.entries(queryParams)
                      .filter(
                        ([, value]) => value !== undefined && value !== "",
                      )
                      .map(
                        ([key, value]) => `${key}=${encodeURIComponent(value)}`,
                      )
                      .join("&");

                  const res =
                    await repositoryPos.get<MessageResponse<any>>(url);

                  if (res && res.success) {
                    NotificationExtension.Success(
                      "Yêu cầu export danh sách đơn đã được gửi thành công. File sẽ được gửi qua thông báo sau khi xử lý xong.",
                    );
                  }
                } catch (error) {
                  console.log(error);
                }
              }}
            >
              Export Excel SLL
            </Button>
          </div>
        </Flex>
        <Grid mt={"10px"}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("keySearch")}
              placeholder="Từ khoá"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("keySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("orderNumber")}
              placeholder="Mã đơn hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("orderNumber")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("codeCustomer")}
              placeholder="Mã khách hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("codeCustomer")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("phone")}
              placeholder="SĐT khách hàng"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("phone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("BuyerPhone")}
              placeholder="SĐT người mua"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("BuyerPhone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("SalePhone")}
              placeholder="SĐT người bán"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("SalePhone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("orderType")}
              searchable
              clearable
              placeholder="Loại đơn hàng"
              comboboxProps={{
                transitionProps: { transition: "fade-up", duration: 200 },
              }}
              leftSection={<IconMenuOrder color="#15aabf" />}
              data={orderTypes}
              nothingFoundMessage="Dữ liệu không có !"
              renderOption={renderSelectOption}
              {...form.getInputProps("orderType")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("orderStatus")}
              placeholder="Trạng thái đơn hàng"
              clearable
              leftSection={<IconStatusChange color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={orderStatuses}
              {...form.getInputProps("orderStatus")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={dataBranch.length || form.key("invId")}
              searchable
              clearable
              placeholder="Chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch.map((item) => {
                return {
                  label: `${item.att2} - ${item.text}`,
                  value: item.value,
                };
              })}
              {...form.getInputProps("invId")}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              key={listEmployeeSales.length || form.key("CodeSal")}
              placeholder="Tìm người hưởng số"
              data={listEmployeeSales}
              {...form.getInputProps("CodeSal")}
              // onChange={(value) => {
              //   handleChangeSearchReturn(String(value || ""), "CodeSal");
              // }}
              leftSection={<IconSearch color="#15aabf" />}
              clearable
              searchable
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              key={form.key("StartDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              {...form.getInputProps("StartDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("EndDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              {...form.getInputProps("EndDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("FinishDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Thời gian hoàn thành đơn"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("FinishDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("OwDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Ngày xuất kho"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("OwDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("VourcherCode")}
              placeholder="Mã vourcher"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("VourcherCode")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              key={form.key("attribute19")}
              placeholder="Mã chứng từ gốc"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("attribute19")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={form.key("saleChannelId")}
              placeholder="Kênh bán"
              leftSection={<IconSandbox color="#15aabf" />}
              data={[
                { label: "Lazada", value: "304" },
                { label: "Tiktok", value: "341" },
                { label: "Chat Zalo", value: "343" },
                { label: "Facebook", value: "62" },
                { label: "Shopee Mall", value: "63" },
                { label: "Shopee", value: "342" },
                { label: "Tổng đài", value: "66" },
                { label: "Khách đến showroom", value: "67" },
                { label: "Khách đặt đơn Website", value: "68" },
                { label: "Khách gọi điện cho nhân viên", value: "69" },
                { label: "Khách chat qua website", value: "101" },
              ]}
              {...form.getInputProps("saleChannelId")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Flex align={"center"} gap={10} wrap={"wrap"}>
              <Checkbox
                label="Đơn Mobile"
                key={form.key("SourceOrderType")}
                {...form.getInputProps("SourceOrderType", { type: "checkbox" })}
              />
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                loading={isLoading}
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>

      <WarrantyHistoryModal
        opened={warrantyModalOpened}
        onClose={() => setWarrantyModalOpened(false)}
        data={warrantyData}
        orderNumber={currentOrderNumber}
      />
    </>
  );
};

export default SalesOrderViewV2;
